import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import s from '../../../redux/selectors';
import a from '../../../redux/actions';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';

const Simple = ({
  t,
  updateNumericInput,
  inputFootprintTransportationPublictrans,
  inputFootprintTransportationAirtotal,
  isMetric,
}) => (
  <div>
    <div className="panel panel-default">
      <div className="panel-heading">{t('Public Transit')}</div>
      <div className="panel-body">
        <div className="input-group">
          <input
            aria-label={isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}
            className="form-control cc-component__question-input--right"
            onChange={e =>
                updateNumericInput({ transportation_publictrans: e.target.value })
              }
            value={inputFootprintTransportationPublictrans.inputDisplay}
            placeholder={inputFootprintTransportationPublictrans.defaultDisplay}
          />
          <span className="input-group-addon">{isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}</span>
        </div>
      </div>
    </div>
    <div className="panel panel-default">
      <div className="panel-heading">{t('Air Travel')}</div>
      <div className="panel-body">
        <div className="input-group">
          <input
            aria-label={isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}
            className="form-control cc-component__question-input--right"
            onChange={e =>
                updateNumericInput({ transportation_airtotal: e.target.value })
              }
            value={inputFootprintTransportationAirtotal.inputDisplay}
            placeholder={inputFootprintTransportationAirtotal.defaultDisplay}
          />
          <span className="input-group-addon">{isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}</span>
        </div>
      </div>
    </div>
  </div>
  );

Simple.propTypes = {
  t: PropTypes.func.isRequired,
  updateNumericInput: PropTypes.func.isRequired,
  isMetric: PropTypes.bool.isRequired,
  inputFootprintTransportationAirtotal: types.UserInput.isRequired,
  inputFootprintTransportationPublictrans: types.UserInput.isRequired,
};
const mapStateToProps = (state, ownProps) => [
  'inputFootprintTransportationAirtotal',
  'inputFootprintTransportationPublictrans',
  'isMetric',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateNumericInput',
  ]),
  dispatch,
);

export default wrap(
  withT('travel'),
  connect(mapStateToProps, mapDispatchToProps)(Simple),
);
